import { alpha, makeStyles, Theme } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabs:{
    backgroundColor:'#f7f0f1',
    color:'#c4122f'
  },
  marginBottom10: {
    marginBottom: 10,
  },
  selectCheck: {
    width: 250,
  },
  marginTop15: {
    marginTop: 15,
  },
  marginTop10: {
    marginTop: 10,
  },
  g_name: {
    marginTop: 20,
  },
  customTextField: {
    borderWidth: 2,
    borderRadius: 5,
    borderColor: "#C5C5C5",
    padding: 10,
    "&:hover": {
      borderColor: "#C4122F",
    },
    "&::placeholder": {
      color: "#C5C5C5",
      fontSize: 16,
    },
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: "#C4122F",
    whiteSpace: "nowrap",
    marginBottom: theme.spacing(1),
  },
  closeButton: {
    border: "0.5px solid #E08489",
    width: 100,
    height: 40,
    borderRadius: 5,
    "&:hover": {
      borderColor: "#c4122f",
    },
  },
  padding5: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  person: { paddingTop: 2, fontSize: 26 },
  iconPerson: { marginRight: 10, marginTop: 5 },
  iconDelete: {
    margin: 0,
  },
  total: { marginLeft: 15, paddingTop: 12, fontWeight: "bold" },
  panelContainer1: { width: "100%", "&:hover": { backgroundColor: "#F5F5F5" } },
  panelContainer2: {
    width: "100%",
    borderTop: "1px solid #E0E0E0",
    "&:hover": { backgroundColor: "#F5F5F5" },
  },
  panelRow: {
    width: "28.5%",
    paddingBottom: "1.3%",
    paddingTop: 15,
    paddingLeft: "5%",
    fontWeight: "inherit",
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "0.875rem",
    "&:hover": {
      cursor: "pointer",
    },
  },
  panelEmail: { width: "61%", paddingBottom: "1.3%", paddingTop: 15 },
  deleteIcon: { display: "flex", justifyItems: "flex-end", marginRight: 5 },
  icon: { fontWeight: "bold", color: "black" },
  label: {
    fontSize: 16,
    paddingTop: 10,
  },
  select: {
    width: 250,
  },
  searchRoot: {
    border: "1px solid #BDBDBD",
    width: "25%",
    height: 40,
    borderBottomWidth: 2,
    borderRadius: 5,
    "&:hover": {
      borderColor: "#c4122f",
      borderBottomWidth: 2,
    },
  },
  searchBar: {
    width: "100%",
    height: 40,
    marginBottom: 0.5,
    "&:hover": {
      borderBottomWidth: 2,
      borderBottomColor: "black",
    },
  },
  searchIcon: {
    margin: 9,
    color: "grey",
    fontWeight: 400,
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "1.2rem",
  },
  closeSearch: {
    color: "grey",
    fontWeight: 400,
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "1.2rem",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    paddingLeft: 0,
    width: "13rem",
    paddingTop: 0,
    paddingBottom: 0,
    fontWeight: 400,
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "0.875rem",
  },
  table: {
    minWidth: 650,
  },
  lableFontSize: {
    fontSize: "x-small",
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    marginBottom: 10,
  },
  button: {
    "& .MuiButton-startIcon": {
      transition: "transform 0.5s",
    },
    "&.rotate .MuiButton-startIcon": {
      transform: "rotate(90deg)",
    },
  },
  panelUrl: {
    width: "67%",
    paddingBottom: "1.3%",
    paddingTop: 15,
    fontWeight: "inherit",
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "0.875rem",
    "&:hover": {
      cursor: "pointer",
    },
  },
  treeDropDown: {
    width: "100%",
    height: 38,
    backgroundColor: "#ffff",
    border: "2px solid #BDBDBD!important",
    marginTop: 5,
    zIndex: 1111111,
    "&:hover": {
      "&:hover": {
        borderColor: "#c4122f!important",
        borderBottomWidth: 2,
      },
    },
  },
  restrict: {
    display: "flex",
    justifyContent: " center",
    alignItems: " center",
    gap: "4px",
  },
  restrictIcon: {
    display: "flex",
    justifyContent: " center",
    alignItems: " center",
  },
  chackBox: {
    color: "#c4122f",
    fontSize: 13,
  },
}));
